import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
    getCookieConsent,
    OPEN_COOKIE_SETTINGS_EVENT,
    setCookieConsent,
} from "../../utils/cookieConsent";
import withPolicyLinks from "../../utils/withPolicyLinks";

// Shown until the visitor accepts or declines analytics and advertising
// cookies, and again from the footer's "Cookie settings" link.
// Bracket values where Bootstrap's !important utilities (p-4, gap-3, bg-white...)
// would win.
export default function CookieConsent() {
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        // Opened once mounted: only the browser knows the visitor's answer,
        // and the page drawn at build time must start out the same.
        setOpen(!getCookieConsent());

        const show = () => setOpen(true);
        window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, show);
        return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, show);
    }, []);

    if (!open) return null;

    const choose = (consent) => {
        setCookieConsent(consent);
        setOpen(false);
    };

    return (
        <div
            role="region"
            aria-label={t("cookies.settings")}
            className="fixed inset-x-0 bottom-0 z-[1040] px-[12px] pb-[12px]"
        >
            <div className="mx-auto flex max-w-3xl flex-col gap-[12px] rounded-2xl bg-[#fff] px-[16px] py-[14px] shadow-[0_8px_30px_rgba(0,0,0,0.15)] sm:flex-row sm:items-center sm:gap-[20px]">
                <p className="text-sm leading-snug text-[#323232]">
                    {withPolicyLinks(t("cookies.message"), i18n.language)}
                </p>
                <div className="flex shrink-0 gap-[8px]">
                    <Button
                        variant="light"
                        className="eufy-button eufy-button-secondary"
                        onClick={() => choose("denied")}
                    >
                        {t("cookies.decline")}
                    </Button>
                    <Button
                        variant="dark"
                        className="eufy-button"
                        onClick={() => choose("granted")}
                    >
                        {t("cookies.accept")}
                    </Button>
                </div>
            </div>
        </div>
    );
}
